/** 금액 부동소수 잔차 제거 — 표시·합산 공통 */

export function money2(amount) {
  if (amount == null || amount === "") return 0;
  const n = Number(String(amount).replace(/,/g, ""));
  return Number.isFinite(n) ? Number(n.toFixed(2)) : 0;
}

/** 부가세 10% (정수 원 기준) */
export function surtax10(amount) {
  const base = Math.trunc(Number(amount) || 0);
  return money2(base / 10);
}

/**
 * 표시용 — IEEE 잔차(소수 자릿수 과다)만 정리.
 * 환율·퍼센트·건수 등 정상 소수값은 건드리지 않음.
 */
export function sanitizeFloatDisplay(value) {
  if (typeof value === "number" && Number.isFinite(value)) {
    const frac = String(value).split(".")[1];
    if (frac && frac.length > 6) return money2(value);
    return value;
  }
  if (typeof value === "string" && /^-?\d+\.\d{7,}$/.test(value.trim())) {
    return money2(value);
  }
  return value;
}
